import {OrderProductModel} from "../Models/OrderModel";
import {useGetReductionFromPercentage} from "./useGetReductionFromPercentage";

export const useUpdateOrderWithPercentDiscount = (): (p: OrderProductModel, quantity: number) => OrderProductModel => {
    const [getTotalMinusReduction, getReduction] = useGetReductionFromPercentage()

    return (p: OrderProductModel, quantity: number): OrderProductModel => {
        const rate = p.discountRate || 0
        const unitPriceTTC = p.unitPriceTTC || 0
        const unitDepositPriceTTC = p.unitDepositPriceTTC || 0
        const unitPriceHT = p.unitPriceHT || 0
        const discount = getReduction(unitPriceTTC * quantity, rate)
        const totalPriceHT = +(getTotalMinusReduction(unitPriceHT * quantity, rate).toFixed(5)) + (unitDepositPriceTTC * quantity)
        const totalPriceTTC = +(getTotalMinusReduction((unitPriceTTC - unitDepositPriceTTC) * quantity, rate) + (unitDepositPriceTTC * quantity)).toFixed(2)
        const totalDepositPriceTTC = p.unitDepositPriceTTC ? p.unitDepositPriceTTC * quantity : 0
        return {
            ...p,
            quantity,
            discount,
            totalPriceHT,
            totalPriceTTC,
            totalDepositPriceTTC,
            totalTva: totalPriceTTC - totalPriceHT,
        }
    }
}
